import React from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';

export const useRmwPaths = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);
  const paths = React.useMemo(() => {
    return environment.paths;
  }, [environment.paths]);
  return paths;
};
